export enum EntitiesListPermission {
    ADMIN = 'admin',
    MANAGER = 'manager',
    PEER = 'peer',
    SELF = 'self',
}
